import React from 'react';
import Helmet from 'react-helmet';

import { DataManagementShell } from 'web-ui-components/lib/layout/shells';
import { SubsectionHeading } from 'web-ui-components/lib/typography/headings';
import { BulletList, NumberList } from 'web-ui-components/lib/typography/lists';
import {
  NavigationButton,
  NavigationButtonGroup,
} from 'web-ui-components/lib/navigation/buttons';

import InternetBankingActions from '../../actions/InternetBankingActions';

import StepHeader from '../../includes/StepHeader';

function GivingNoticePage() {
  const numberListItems = [
    "Go to your 'Secure messages'",
    "Choose 'Business Notice withdrawal' from the drop-down menu",
    "Pick the Business Notice Account you'd like to make a withdrawal from",
  ];

  const bulletListItems = [
    'Your mobile number',
    'Notice account details',
    ['Sort code', 'Account number', 'Amount to withdraw'],
    'Account to send money to',
    [
      'Name on account (this should be the same name as your business)',
      'Bank',
      'Sort code',
      'Account number',
    ],
  ];

  return (
    <div>
      <Helmet title={'Giving Notice'} />
      <DataManagementShell>
        <StepHeader
          onClick={() =>
            InternetBankingActions.navigateToWebTask('WEB-HOMEPAGE')
          }
          headerCrumbsMessage="Back"
          headerTitle={'Making a withdrawal from a Notice Account'}
          showheaderCrumbs
        />
        <SubsectionHeading>How to make a withdrawal</SubsectionHeading>
        <NumberList items={numberListItems} />
        <SubsectionHeading>Include in your message</SubsectionHeading>
        <BulletList items={bulletListItems} />
        <br />
        <NavigationButtonGroup
          primaryButton={
            <NavigationButton.Primary
              labelText="Secure Messages"
              onClick={() =>
                InternetBankingActions.navigateToWebTask('WEB-SECURE-MESSAGE')
              }
            />
          }
          secondaryButtons={
            <NavigationButton.Secondary
              labelText="Back"
              onClick={() =>
                InternetBankingActions.navigateToWebTask('WEB-HOMEPAGE')
              }
            />
          }
        />
      </DataManagementShell>
    </div>
  );
}

export { GivingNoticePage };
